import React, { useEffect, useState } from "react";
import { Card } from "@material-tailwind/react";

import { useNavigate, useParams } from "react-router";

import NavigationBar from "../../component/NavigationBar";
import Footer from "../../component/Footer";

import AgentInfo from "../../component/agent/AgentInfo";
import { getAgent } from "../../../service/AgentService";
import PropertyCard from "../../component/PropertyCard";
import { currencyFormat } from "../../../helper/numberHelper";
import CalculatorKPR from "../../component/CalculatorKPR";

function KPRKalkulator({
  
}) {

  return (
    <>
      <NavigationBar fixed/>
      <section className="px-4 md:px-12">
        <div className="container mx-auto mt-8 grid grid-cols-1 gap-y-2 lg:grid-cols-4 lg:gap-x-6">
          <div className="col-span-2">
            <Card>
              <div className="mt-6 px-4 mb-10 md:px-12 h-fit center">
              <CalculatorKPR />
              </div>
            </Card>
          </div>
        </div>
      </section>
      <Footer showSiteMap/>
    </>
  );
}

export default KPRKalkulator;